<div class="sent-details">
    <span class="sent-details__title">
        {{title}}
    </span>
    <div class="sent-details__data">
        <span class="sent-details__data__title">{{'vehicle-details-etoll-tab.business-number' | translate}}</span>
        <span class="sent-details__data__value">
            {{ vehicle.BN }}
        </span>
        <button (click)="copyText(vehicle.BN)" class="sent-details__data__copy">
            <img src="/assets/images/shared/i-copy-black.svg" alt="">
        </button>
    </div>
    <div class="sent-details__data">
        <span class="sent-details__data__title">{{'labels.pin'|translate}}:</span>
        <span class="sent-details__data__value">
            {{ vehicle.DP }}
        </span>
        <button (click)="copyText(vehicle.DP)" class="sent-details__data__copy">
            <img src="/assets/images/shared/i-copy-black.svg" alt="">
        </button>
    </div>
    <p-button (onClick)="copyAll()" class="sent-details__copy-all" [label]="'copyAllData'|translate"></p-button>
</div>
